module.exports = __webpack_public_path__ + "582d551cfe2b60b28e0b9636ff88e3c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-folder.svg
// module id = 2007
// module chunks = 0